<template>
    <VForm
        v-slot="{ errors }"
        @submit="onSubmit">
        <div class="flex flex-col gap-6">
            <BaseInput
                v-model="model.code"
                :label="$t('auth.code')"
                rules="required|digits:6"
                required
                name="code"
                :description="$t('users.twoFactor.enterCodeFromApp')"
                autocomplete="one-time-code" />

            <BaseButton
                class="w-full"
                color="primary"
                :disabled="loading || !!Object.keys(errors).length"
                type="submit">
                <span v-if="!loading">{{ $t('auth.login') }}</span>
                <span v-else>
                    <LoadingSpinner />
                    {{ $t('auth.pleaseWait') }}
                </span>
            </BaseButton>
        </div>
    </VForm>
</template>

<script setup>
import {useAuthStore} from '@/store/auth'

const authStore = useAuthStore()

defineEmits(['authPageVisible'])

const model = ref({
    code: null
})

const loading = ref(false)

async function onSubmit() {
    loading.value = true
    const response = await $lara.post('app/spa/two-factor-challenge', {body: model.value})
    loading.value = false
    if (response?.error) return
    await authStore.successfulLogin()
}
</script>